import { TS_ItemType } from './TS_ItemType';
import { TS_Item }     from './TS_Item';

export class TS_BonuscardOrder extends TS_Item {
    type = TS_ItemType.BONUSCARD_ORDER;
}